import { getUserLid } from 'Compass/profile-lab/hooks/useUserLid';
import { fetchSignedUrls } from 'Compass/profile-lab/services/ProfileLabService';

export const fetchSignedUrlsForCurrentUser = async (photoLids: number[]): Promise<Record<number, string>> => {
  const userLid = await getUserLid();
  return await fetchSignedUrls(userLid, photoLids);
};
